module.exports = __webpack_public_path__ + "img/124.7a7cf0cb.jpg";